<script setup>
import { ref, defineAsyncComponent } from "vue";
import loadAnimationData from "~/assets/images/loading.json";

const lottieReady = ref(false);
const LottieAnimation = defineAsyncComponent(() => import("~/components/lottie-animation.vue"));

defineProps({
	/** fullscreen: 盖住整页；inline: 内容区占位 */
	mode: {
		type: String,
		default: "inline",
		validator: v => ["inline", "fullscreen"].includes(v),
	},
});
</script>

<template>
	<div class="global-page-loading" :class="`global-page-loading--${mode}`">
		<div v-if="!lottieReady" class="global-page-loading__spinner" aria-hidden="true" />
		<LottieAnimation
			v-show="lottieReady"
			class="global-page-loading__animation"
			:animation-data="loadAnimationData"
			@vue:mounted="lottieReady = true"
		/>
	</div>
</template>

<style scoped>
.global-page-loading {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	box-sizing: border-box;
}

.global-page-loading--inline {
	min-height: 60vh;
	padding: 40px 16px;
}

.global-page-loading--fullscreen {
	position: fixed;
	inset: 0;
	z-index: 9999;
	/* background: rgba(255, 255, 255, 0.92); */
}

.global-page-loading__spinner {
	width: 40px;
	height: 40px;
	border: 4px solid #f3f3f3;
	border-top: 4px solid #333333;
	border-radius: 50%;
	animation: global-page-loading-spin 1s linear infinite;
}

.global-page-loading__animation {
	width: 120px;
	height: 120px;
}

@keyframes global-page-loading-spin {
	to {
		transform: rotate(360deg);
	}
}
</style>
